import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagenRightElement.vue?vue&type=template&id=5407b07c&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagenRightElement.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagenRightElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5407b07c",
  null
  
)

export default component.exports